import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyContactBar from "@/components/StickyContactBar";
import HomePage from "@/pages/HomePage";
import TreatmentsPage from "@/pages/TreatmentsPage";
import TreatmentDetailPage from "@/pages/TreatmentDetailPage";
import AboutPage from "@/pages/AboutPage";
import LocationsPage from "@/pages/LocationsPage";
import HelpfulResourcesPage from "@/pages/HelpfulResourcesPage";
import OnlinePhysiotherapyPage from "@/pages/OnlinePhysiotherapyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="pb-16 md:pb-0">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/treatments" element={<TreatmentsPage />} />
            <Route path="/treatment/:id" element={<TreatmentDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/resources" element={<HelpfulResourcesPage />} />
            <Route path="/online-physiotherapy" element={<OnlinePhysiotherapyPage />} />
          </Routes>
        </main>
        <Footer />
        <StickyContactBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
